import * as Actions from '../actions';

const initialState = {
    studentQuiz: {
        header: {
            student_quiz_id: 0,
            quiz_id:         0,
            student_id:      0,
            auth_id:         0,
            TimeTaken:       0,
            Attempt:         0,
            StartTime:       0,
            EndTime:         0,
            Score:           0,
        },
        student: {
            header: {
                student_id:  0,
                FirstName:   '',
                LastName:    '',
                Email:       '',
                Active:      0,
            }
        },
        studentQuestionList: []
    },
    nextEvent: {
        EventName: 'None',
        EventType: 'None',
        company_calendar_event_id: 0
    },
    prevEvent: {
        EventName: 'None',
        EventType: 'None',
        company_calendar_event_id: 0
    }
}

const initialStudentQuestion = {
    student_question_id: 0,
    student_quiz_id:     0,
    question_id:         0,
    question_type_id:    0,
    Score:               0,
    IsGraded:            0,
    studentAnswerList:   [],
}

const initialStudentAnswer = {
    student_answer_id:   0,
    student_quiz_id:     0,
    student_question_id: 0,
    question_id:         0,
    answer_id:           0,
    AnswerText:          '',
    AnswerOrder:         0,
    xPosition:           0,
    yPosition:           0,
    Score:               0,
}

const quizScoreReducer = function (state = initialState, action) {
    switch (action.type) {
        case (Actions.GET_STUDENT_QUIZ):
        {
            return {
                ...state,
                studentQuiz: action.payload
            }
        }

        case (Actions.UPDATE_STUDENT_QUESTION):
        {
            const question_id      = action.payload.question_id;
            const student_quiz_id  = action.payload.student_quiz_id;
            const question_type_id = action.payload.question_type_id;
            const update_data      = action.payload.update_data;

            let student_answer_is_found = false;
            const new_studentQuestionList = state.studentQuiz.studentQuestionList.map((student_question) => {
                if (student_question.question_id === question_id) {
                    student_answer_is_found = true;

                    return {
                        ...student_question,
                        ...update_data,
                        IsGraded: 1,
                    }
                } else {
                    return student_question;
                }
            });

            // Handle Missing Student Questions
            if (!student_answer_is_found) {
                new_studentQuestionList.push({
                    ...initialStudentQuestion,
                    question_id:      question_id,
                    student_quiz_id:  student_quiz_id,
                    question_type_id: question_type_id,
                    IsGraded:         1,
                    ...update_data
                });
            }
            
            const new_total_score = new_studentQuestionList.reduce((prev, cur) => {
                return (Number(prev) + Number(cur.Score)).toFixed(1);
            }, 0);

            return {
                ...state,
                studentQuiz: {
                    ...state.studentQuiz,
                    header: {
                        ...state.studentQuiz.header,
                        Score: new_total_score
                    },
                    studentQuestionList: new_studentQuestionList
                }
            }
        }
        
        case (Actions.UPDATE_STUDENT_QUIZ):
        {
            return {
                ...state,
                studentQuiz: {
                    ...state.studentQuiz,
                    header: {
                        ...state.studentQuiz.header,
                        ...action.payload
                    }
                }
            }
        }

        case (Actions.GET_NEXT_EVENT_FOR_CONTINUE):
        {   
            // if (!action.payload) {
            //     return {
            //         ...state,
            //         nextEvent: action.payload
            //     }
            // }
            return {
                ...state,
                nextEvent: action.payload.nextEvent,
                prevEvent: action.payload.prevEvent
            }
        }

        default:
        {
            return state;
        }

    }
}

export default quizScoreReducer;


// WEBPACK FOOTER //
// src/main/content/quiz/store/reducers/quizScore.reducer.js